// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"detail-technology-header_headerWrapper__LW6Nc","title":"detail-technology-header_title__jst1f"};